module.exports = __webpack_public_path__ + "static/media/statotech2.00084ca4.png";